export default "__VITE_ASSET__b9867224__"